<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>企业申请</span>
        </div>
      </div>
      <div class="coreMain">
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="电话"></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="job" label="职位" :formatter="jobFormat"></el-table-column>
          <el-table-column prop="companySize" label="所属行业" :formatter="industryFormat"></el-table-column>
          <el-table-column prop="handleStatus" label="处理状态" :formatter="statusFormat"></el-table-column>
          <el-table-column prop="createDate" label="创建时间">
            <template slot-scope="scope">
              <span>{{ changeDate(scope.row.createDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:14px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ type: 'edit', id: scope.row.id }">分配账号</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs"
  export default {
    data() {
      return {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        tableData: [],
        multipleSelection: []
      };
    },
    created() { },
    methods: {
      //初始化时间
      changeDate(time) {
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },
      //获取列表数据
      getPage() {
        let para = {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        }
        this.loading = true; /*显示加载条*/
        API.enterprisePage(para).then(res => {
          if (res.code == 1) {
            this.tableData = res.data.resultPage
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false; /*显示加载条*/
        })
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getPage();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getPage();
      },
      command(val) {
        if (val.type == 'edit') {

        }
      },
      jobFormat(row) {
        switch (row.job) {
          case 1:
            return "行政/人事";
            break;

          case 2:
            return "IT运维";
            break;
          case 3:
            return "开发";
            break;
          case 4:
            return "运营";
            break;
          case 5:
            return "其他";
            break;

          default:
            return "---";
        }
      },
      industryFormat(row) {
        switch (row.companySize) {
          case 1:
            return "地产/物业";
            break;

          case 2:
            return "交通";
            break;
          case 3:
            return "电力";
            break;
          case 4:
            return "教育";
            break;
          case 5:
            return "医疗";
            break;
          case 6:
            return "科技";
            break;
          case 7:
            return "其他";
            break;

          default:
            return "---";
        }
      },
      statusFormat(row) {
        switch (row.handleStatus) {
          case 0:
            return "未处理";
            break;
          case 1:
            return "已处理";
            break;
          default:
            return "---";
        }
      },
    },
    mounted() {
      this.getPage();
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/enterpriseApplication.vue